import React, { FC, useState } from 'react';
import { Link } from 'react-router-dom';
import { Marker, InfoWindow } from "@react-google-maps/api";


type Props = {
    data: Spots;
};


export const Spots: FC<Props> = ({ data }) => {
    const [selected, setSelected] = useState<Omit<Spot, 'staffs'> | null>(null);
    const icons = {
        '飲食店': '/img/map_pins/pin-rest.png',
        'ヘアサロン': '/img/map_pins/pin-cut.png',
        'スナックキャンディ': '/img/map_pins/pin-candy.png',
        '宿泊': '/img/map_pins/pin-hotel.png',
        'その他': '/img/map_pins/pin-other.png',
        '自販機': '/img/map_pins/pin-vend.png',
        '居酒屋・バー': '/img/map_pins/pin-bar.png',
        'レストラン・カフェ': '/img/map_pins/pin-cafe.png',
        'スイーツ': '/img/map_pins/pin-sweets.png',
        '健康': '/img/map_pins/pin-health.png',
        '医療・福祉': '/img/map_pins/pin-medical.png',
        '小売': '/img/map_pins/pin-retail.png',
        'エンタメ・レジャー': '/img/map_pins/pin-entertainment.png',
        '習いごと': '/img/map_pins/pin-education.png',
        'ビューティ': '/img/map_pins/pin-beauty.png',
        'レンタルスペース': '/img/map_pins/pin-rentalspace.png',
        'ビジネス': '/img/map_pins/pin-buisiness.png',
        '保育園・幼稚園': '/img/map_pins/pin-nursery.png',
        '農業': '/img/map_pins/pin-agri.png',
    };

    const iconsForCoupon = {
        '飲食店': '/img/map_pins/coupon/pin-rest.png',
        'ヘアサロン': '/img/map_pins/coupon/pin-cut.png',
        'スナックキャンディ': '/img/map_pins/coupon/pin-candy.png',
        '宿泊': '/img/map_pins/coupon/pin-hotel.png',
        'その他': '/img/map_pins/coupon/pin-other.png',
        '自販機': '/img/map_pins/coupon/pin-vend.png',
        '居酒屋・バー': '/img/map_pins/coupon/pin-bar.png',
        'レストラン・カフェ': '/img/map_pins/coupon/pin-cafe.png',
        'スイーツ': '/img/map_pins/coupon/pin-sweets.png',
        '健康': '/img/map_pins/coupon/pin-health.png',
        '医療・福祉': '/img/map_pins/coupon/pin-medical.png',
        '小売': '/img/map_pins/coupon/pin-retail.png',
        'エンタメ・レジャー': '/img/map_pins/coupon/pin-entertainment.png',
        '習いごと': '/img/map_pins/coupon/pin-education.png',
        'ビューティ': '/img/map_pins/coupon/pin-beauty.png',
        'レンタルスペース': '/img/map_pins/coupon/pin-rentalspace.png',
        'ビジネス': '/img/map_pins/coupon/pin-buisiness.png',
        '保育園・幼稚園': '/img/map_pins/coupon/pin-nursery.png',
        '農業': '/img/map_pins/coupon/pin-agri.png',
    };

    return (
        <>
            {data.map((spot) => {
                return (
                    <Marker
                        onUnmount={() => setSelected(null)}
                        key={`${spot.lat * spot.lng}`}
                        position={{ ...spot }}
                        onClick={() => {
                            setSelected(null);
                            setSelected(spot);
                        }}
                        icon={{
                            // @ts-ignore
                            url: spot.hasValidCoupons ? iconsForCoupon[spot.genre] : icons[spot.genre],
                            // @ts-ignore
                            scaledSize: new window.google.maps.Size(36, 52),
                            optimized: true,
                        }}
                    />
                );
            })}

            {selected ? (
                <InfoWindow
                    options={{
                        // @ts-ignore
                        pixelOffset: new google.maps.Size(0, -52),
                    }}
                    position={{ ...selected }}
                    onUnmount={() => setSelected(null)}
                    onCloseClick={() => setSelected(null)}
                >
                    <div className="window">
                        <div className="cover-image-container">
                            <img className="cover-image" width={120} height={40} src={selected.coverImage} alt={selected.name} />
                        </div>
                        <div className="name-container">
                            <a href={`/stores/${selected.id}`}>{selected.name}</a>
                        </div>
                        <div className="description-container">{selected.description}</div>

                        <div className="footer-container">

                            {selected.public && <div className="user-container"><a href={`/members/view/${selected.shortId}`}>
                                <div className="user-info-container">
                                    <div className="profile-image-container">
                                        <img className="profile-image" width={20} height={20} src={selected.facebookId ? `/user_icons/get/dummy?user_id=${selected.userId}` : `${selected.icon_path}`} alt={selected.name} />
                                    </div>
                                    <div className="user-name-container">{selected.contributor}</div>
                                </div>
                            </a></div>}

                            {!selected.public && <div className="user-container">
                                <div className="user-info-container">
                                    <div className="profile-image-container">
                                        <img className="profile-image" width={20} height={20} src={selected.facebookId ? `/user_icons/get/dummy?user_id=${selected.userId}` : `${selected.icon_path}`} alt={selected.name} />
                                    </div>
                                    <div className="user-name-container">{selected.contributor}</div>
                                </div>
                            </div>}

                            {selected.hasValidCoupons && <div className="coupon-container"><a href={`/stores/${selected.id}/coupons`}><div>
                                <img className="badge" width={20} height={20} src="/img/coupon.png" alt="クーポンあり" />
                                <p>クーポンあり</p>
                            </div></a></div>}
                        </div>

                        <style jsx>{`
                        :global(.gm-ui-hover-effect) {
                            width: 32px!important;
                            height: 32px!important;
                            top: 4px!important;
                            right: 4px!important;
                        }
                        :global(.gm-ui-hover-effect > img) {
                            width: 24px!important;
                            height: 24px!important;
                            margin: auto!important;
                        }
                        :global(.gm-style .gm-style-iw-c) {
                            padding: 0;
                        }
                        :global(.gm-style .gm-style-iw-d) {
                            overflow: auto !important;
                        }
                        :global(.gm-style-iw-chr) {
                            position: absolute;
                            z-index: 100;
                            right: 0 !important;
                            top: 0 !important;
                        }
                        :global(.gm-style-iw-ch) {
                            display: none !important;
                        }
                        :global(.gm-ui-hover-effect) {
                            height: 24px !important;
                            top: 90px !important;
                            right: 0 !important;
                        }
                        :global(.gm-ui-hover-effect span) {
                            margin: 0 !important;
                        }
                        .window {
                            width: 200px;
                            position: relative;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            flex-direction: column;
                        }
                        .cover-image-container {
                            width: 100%;
                        }
                        .cover-image-container img {
                            width: 100%;
                            height: 80px;
                            object-fit: cover;
                        }
                        .name-container {
                            color: #FF8025;
                            font-weight: bold;
                            font-size: 14px;
                            line-height: 19.6px;
                            width: 100%;
                            padding: 10px 32px 10px 10px;
                        }
                        .name-container a {
                            color: #FF8025;
                            text-decoration: none;
                        }
                        .description-container {
                            width: 100%;
                            min-height: 24px;
                            font-weight: bold;
                            font-size: 10px;
                            line-height: 14px;
                            margin: 0;
                            padding: 0 10px;
                            overflow: hidden;
                            display: -webkit-box;
                            text-overflow: ellipsis;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 3;
                            word-break: break-all;
                        }
                        .profile-image-container {
                            
                        }
                        .profile-image {
                            border-radius: 50%;
                            width: 32px;
                            height: 32px;
                        }
                        .contributor-container {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                        }
                        .member-benefits-container {
                            display: flex;
                            align-items: center;
                        }
                        .member-benefits-container > img {
                            width: 18px;
                            height: 18px;
                        }
                        .member-benefits-container > p {
                            margin: 0;
                            font-size: 12px;
                            color: black;
                        }
                        .footer-container {
                            width: 100%;
                            display: flex;
                            padding: 10px;
                        }
                        .footer-container .user-container {
                            display: flex;
                            align-items: center;
                            width: 70%;
                        }
                        .footer-container .user-container a {
                            color: black;
                            text-decoration: none;
                        }
                        .footer-container .user-container .user-info-container {
                            display: flex;
                            align-items: center;
                        }
                        .footer-container .user-container .user-name-container {
                            margin-left: 10px;
                            font-weight: bold;
                        }
                        .footer-container .coupon-container {
                            width: 30%;
                            text-align: center;
                        }
                        .footer-container .coupon-container img {
                            width: 40px;
                            height: 40px;
                        }
                        .footer-container .coupon-container a {
                            color: black;
                            text-decoration: none;
                            display: block;
                            scale: 1;
                            animation: yurayura 2s linear infinite;
                        }
                        .footer-container .coupon-container p {
                            font-weight: bold;
                            font-size: 9px;
                            margin-top: 0;
                        }
                        @keyframes yurayura{
                            0%  {transform:rotate(0deg);}
                            25% {transform:rotate(-10deg);}
                            50% {transform:rotate(0deg);}
                            75% {transform:rotate(10deg);}
                            100% {transform:rotate(0deg);}
                        }
                        h1 {
                            max-width: 190px;
                            font-size: 16px;
                            margin-top: 0;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                        .contributor {
                            max-width: 190px;
                            text-align: left;
                            font-size: 16px;
                            font-weight: bold;
                            text-decoration: underline solid black;
                            word-break: break-all;
                            color: black;
                            padding: auto;
                            margin-top: 10px;
                        }
                        @media screen and (max-width: 540px){
                            .window {
                                min-width: 170px;
                                min-height: 170px;
                            }
                            h1 {
                                max-width: 160px
                                font-size: 12px;
                                margin-bottom: 16px;
                            }
                            .profile-image-container {
                                padding: 0px 18px 0px 18px;
                            }
                            .contributor {
                                max-width: 160px;
                                font-size: 16px;
                            }
                            .member-benefits-container > img {
                                width: 16px;
                                height: 16px;
                            }
                        }
                    `}</style>
                    </div>
                </InfoWindow>
            ) : null}
        </>
    );
};
